import React from "react";
import { Link, useParams } from "react-router-dom";
import { Button, Divider } from "@mui/material";
import { EditOutlined } from "@mui/icons-material";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import { useGetSmsProviderDetailQuery } from "store/services/smsProviderApi";

import {
  SmsProviderDetailContext,
  useSmsProviderDetailContext,
} from "contexts/SmsProviderDetailContext";
import SmsProviderDetailTab from "./components/SmsProviderDetailTab";
import SmsProviderBasicDetail from "./components/SmsProviderBasicDetail";

const SmsProviderDetailScreen = () => {
  const { id } = useParams();

  const breadcrumbs = [
    { title: "SMS Providers", path: "/app/crm/sms-provider/list" },
    { title: "SMS Provider Detail" },
  ];

  // RTK Query
  const {
    data: smsProviderDetail,
    isLoading: loadingSmsProvider,
    error,
  } = useGetSmsProviderDetailQuery(id);

  return (
    <SmsProviderDetailContext.Provider
      value={{ smsProviderDetail, loadingSmsProvider }}
    >
      <BreadcrumbLayout
        breadcrumbs={breadcrumbs}
        isBusy={loadingSmsProvider}
        headerActions={<PageActions />}
      >
        <BreadcrumbLayout.Error error={error} />

        <BreadcrumbLayout.Paper>
          <SmsProviderBasicDetail />
          <Divider />
          <SmsProviderDetailTab />
        </BreadcrumbLayout.Paper>
      </BreadcrumbLayout>
    </SmsProviderDetailContext.Provider>
  );
};

export default SmsProviderDetailScreen;

const PageActions = () => {
  const { smsProviderDetail } = useSmsProviderDetailContext();
  return (
    <div className="flex items-center gap-4">
      <Link to={`/app/crm/sms-provider/${smsProviderDetail?._id}/edit`}>
        <Button startIcon={<EditOutlined />} variant="contained">
          Edit
        </Button>
      </Link>
    </div>
  );
};